import { useState } from "@erp/shared/composables/useState";
import { defineStore } from "pinia";
export const useIsOrderCommercialStore = defineStore("is-order-commercial", () => {
    const [isCommercial, setIsCommercial] = useState(true);
    return { isCommercial, setIsCommercial };
});
